import { AssembleiaIcon, CommunityIcon, DialogIcon, PeopleIcon } from 'components/Icons';
import { AssembleiaAssessorRoutePath, ConvocadosAssessorRoutePath, MensagensAssessorRoutePath, RelatorioPresentesRoutePath } from 'library/Routes';
import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { IAssembleiasAssessorEventList, IAssembleiasAssessorReducer } from 'store/modules/AssembleiasAssessorReducer';
import { history } from 'store/Store';
import { Submenu } from './components';

interface Props {
  assembleias?: IAssembleiasAssessorReducer;
  loader: Function;
  closeMenu: Function;
  needLoad: boolean;
}

export default function ({ assembleias, loader, closeMenu, needLoad }: Props) {
  const { t } = useTranslation();
  const [currentPath, setCurrentPath] = useState<string>(window.location.pathname);
  const onChangedLocation = () => setCurrentPath(window.location.pathname);

  const eventos = useMemo<IAssembleiasAssessorEventList[]>(() => {
    return (assembleias?.listaEvento || []).filter(
      it => {
        return it.status === 2
      }
    )
  }, [assembleias])

  useEffect(() => {
    const urlChangeUnlisten = history.listen(onChangedLocation);
    return () => urlChangeUnlisten();
  }, []);

  useEffect(() => {
    if (needLoad) {
      loader();
    }
  }, [loader, needLoad]);

  return (
    <React.Fragment>
      <Submenu
        name={t('LeftMenu.events')}
        icon={<AssembleiaIcon />}
        isLoading={assembleias?.loadingListaEvento}
        items={eventos.map(event => ({
          path: AssembleiaAssessorRoutePath.replace(':id', `${event.id}`),
          icon: <AssembleiaIcon />,
          text: event.nome,
          closeMenu,
        }))}
        isCurrent={currentPath.startsWith('/assembleiadefundos/assessor/assembleia') && !currentPath.endsWith('/presentes')}
      />
      <Submenu
        name={t('LeftMenu.convocados')}
        icon={<CommunityIcon />}
        isLoading={assembleias?.loadingListaEvento}
        items={eventos.map(event => ({
          path: ConvocadosAssessorRoutePath.replace(':id', `${event.id}`),
          icon: <CommunityIcon />,
          text: event.nome,
          closeMenu,
        }))}
        isCurrent={currentPath.startsWith('/assembleiadefundos/assessor/convocados')}
      />
      <Submenu
        name={t('LeftMenu.messages')}
        icon={<DialogIcon />}
        isLoading={assembleias?.loadingListaEvento}
        items={eventos
          .map(assembleia => ({
            path: MensagensAssessorRoutePath.replace(':idEvento', `${assembleia.id}`),
            icon: <DialogIcon />,
            text: assembleia.nome,
            closeMenu,
          }))}
        isCurrent={currentPath.startsWith('/assembleiadefundos/assessor/mensagens')}
      />
      <Submenu
        name={t('LeftMenu.presentes')}
        icon={<PeopleIcon />}
        isLoading={assembleias?.loadingListaEvento}
        items={eventos
          .map(assembleia => ({
            path: RelatorioPresentesRoutePath.replace(':idAssembleia', `${assembleia.id}`),
            icon: <PeopleIcon />,
            text: assembleia.nome,
            closeMenu,
          }))}
        isCurrent={currentPath.startsWith('/assembleiadefundos/assessor/assembleia') && currentPath.endsWith('/presentes')}
      />
    </React.Fragment>
  );
}
